// @flow
import EmptyReport from './EmptyReport';

export default EmptyReport;
